import storage from '../storage'

const sendbirdTokenFromConfig = window.config ? window.config.sendbirdToken : ''
const solutions = window.config ? window.config.solutions : []

export function getSendbirdToken() {
  let _token = sendbirdTokenFromConfig
  let _solution = storage.local.getItem('auth/solution') || 1

  solutions.forEach(item => {
    if (parseInt(item.id) === parseInt(_solution)) {
      _token = item.sendbirdToken
    }
  })
  return _token
}
